import { render, staticRenderFns } from "./ValidationConfirm.vue?vue&type=template&id=2d7ccf78"
import script from "./ValidationConfirm.vue?vue&type=script&lang=js"
export * from "./ValidationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports